var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt100 pb100 fs20"},[_c('h3',{staticClass:"flex aic jcc"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }